import React from 'react';
import { supportsProviderSync } from '../utils/pharmacies';
import styled from 'styled-components';

const INITIAL_COUNT = 3;

const ProviderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem 0.5rem;
  border-radius: 5px;
  background-color: var(--input-bg);
  border: 1px solid var(--border-color);
  font-size: 0.875rem;
  color: var(--text-color);
`;

const RowIndex = styled.span`
  min-width: 1.25rem;
  font-weight: 600;
  color: var(--text-secondary);
  font-size: 0.75rem;
`;

const ToggleButton = styled.button`
  margin-top: 0.25rem;
  padding: 0.375rem 0.5rem;
  background: none;
  border: 1px dashed var(--border-color);
  border-radius: 5px;
  font-size: 0.8rem;
  cursor: pointer;
  text-align: left;
  width: 100%;
`;


export default function PharmacyProviderList({
  pharmacy,
  pharmacyProviders,
  expandedProviders,
  setExpandedProviders,
}) {
  if (!supportsProviderSync(pharmacy.pharmacy_name)) return null;

  const pid = pharmacy.pharmacy_id;
  const providerData = pharmacyProviders[pid] || { providers: [], count: 0 };
  const allProviders = providerData.providers;
  const totalCount = providerData.count;
  const isExpanded = !!expandedProviders[pid];
  const visible = isExpanded ? allProviders : allProviders.slice(0, INITIAL_COUNT);
  const remaining = allProviders.length - INITIAL_COUNT;

  const toggle = (expanded) =>
    setExpandedProviders((prev) => ({ ...prev, [pid]: expanded }));

  return (
    <div>
      <div style={{ fontSize: '1rem', fontWeight: '500', marginBottom: '0.5rem', color: 'var(--text-secondary)' }}>
        Providers ({totalCount})
      </div>

      {allProviders.length === 0 ? (
        <span style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
          No providers assigned
        </span>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
          {visible.map((p, idx) => {
            const displayName =
              p.name ||
              p.display_name ||
              `${p.first_name || ''} ${p.last_name || ''}`.trim();
            return (
              <ProviderRow key={p.provider_id}>
                <RowIndex>{idx + 1}.</RowIndex>
                <span>
                  {displayName}
                  {p.credential ? `, ${p.credential}` : ''}
                </span>
              </ProviderRow>
            );
          })}

          {!isExpanded && remaining > 0 && (
            <ToggleButton
              type="button"
              onClick={() => toggle(true)}
              style={{ color: 'var(--primary)' }}
            >
              + Load More ({remaining} more)
            </ToggleButton>
          )}

          {isExpanded && allProviders.length > INITIAL_COUNT && (
            <ToggleButton
              type="button"
              onClick={() => toggle(false)}
              style={{ color: 'var(--text-secondary)' }}
            >
              − Show Less
            </ToggleButton>
          )}
        </div>
      )}
    </div>
  );
}
